import { render, staticRenderFns } from "./getRecord.vue?vue&type=template&id=7af1e5d7&scoped=true&"
import script from "./getRecord.vue?vue&type=script&lang=js&"
export * from "./getRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af1e5d7",
  null
  
)

export default component.exports